import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useConnect, useAccount, useDisconnect, useConfig } from "wagmi";

const SidebarDesktop = ({openModal}) => {
  const { address, isConnected } = useAccount();
  const { disconnect } = useDisconnect();
  const location = useLocation();
  const hiddenRoutes = ["/", "/documentation", "/whitepaper"];
  const hideButton = hiddenRoutes.includes(location.pathname);
  return (
    <>
      <div className="header-right">
        <nav className="nav">
          <ul>
            <li>
              <a
                href="/documentation"
                target="_blank"
                rel="noopener noreferrer"
              >
                Documentation
              </a>
            </li>
            <li>
              <div className="dropdown">
                <button className="dropdown-button">
                  SERVICES
                  <span className="dropdown-arrow">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      aria-hidden="true"
                      role="img"
                      className="iconify iconify--oui"
                      width="1em"
                      height="1em"
                      viewBox="0 0 16 16"
                    >
                      <path
                        fill="currentColor"
                        d="m2.931 10.843l4.685-4.611a.546.546 0 0 1 .768 0l4.685 4.61a.55.55 0 0 0 .771 0a.53.53 0 0 0 0-.759l-4.684-4.61a1.65 1.65 0 0 0-2.312 0l-4.684 4.61a.53.53 0 0 0 0 .76a.55.55 0 0 0 .771 0"
                      ></path>
                    </svg>
                  </span>
                </button>

                {/* Dropdown Menu */}
                <div className="dropdown-content dropdown-menu left-bottom">
                  <div className="dropdown-content-scroll">
                    <Link to="/staking"><div className="dropdown-item">Staking</div></Link>
                    <Link to="#"><div className="dropdown-item">AI Chat Builder</div></Link>
                    <Link to="/analysis"><div className="dropdown-item">Trading Analysis Agent</div></Link>
                    <Link to="#"><div className="dropdown-item">AI Process Automation</div></Link>
                  </div>
                </div>
              </div>
            </li>
            <li>
              <a
                href="/whitepaper"
                target="_blank"
                rel="noopener noreferrer"
              >
                Whitepaper
              </a>
            </li>
            <li>
              <a href="mailto:contact@aiflowtoken.com">Contact</a>
            </li>
            {!hideButton && (
            <li>
              <button className="btn" data-colors="primary" onClick={isConnected ? disconnect : openModal}>
                <span className="btn-txt">{isConnected ? address.slice(0, 6) + "..." : "Login"}</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                  aria-hidden="true"
                  role="img"
                  className="iconify iconify--carbon"
                  width="1em"
                  height="1em"
                  viewBox="0 0 32 32"
                >
                  <path fill="currentColor" d="M22 17h2v2h-2z"></path>
                  <path
                    fill="currentColor"
                    d="M28 8H4V5h22V3H4a2 2 0 0 0-2 2v21a2 2 0 0 0 2 2h24a2 2 0 0 0 2-2V10a2 2 0 0 0-2-2M4 26V10h24v3h-8a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h8v3Zm24-11v6h-8v-6Z"
                  ></path>
                </svg>
                <div className="corner" data-colors="primary">
                  <span className="corner-left"></span>
                  <span className="corner-right"></span>
                  <span className="corner-top-bottom"></span>
                </div>
              </button>
            </li>
            )}
            <li>
              <Link
                to="/dashboard"
                className="btn"
                data-colors="primary"
              >
                <span className="btn-txt">Buy AIFL</span>
            {/* <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="1em"
                  height="1em"
                  viewBox="0 0 16 16"
                  fill="currentColor"
                >
                  <use href="/assets/sprites-JdJ7Xybh.svg#uniswap"></use>
                </svg>*/}
                <div className="corner" data-colors="primary">
                  <span className="corner-left"></span>
                  <span className="corner-right"></span>
                  <span className="corner-top-bottom"></span>
                </div>
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    </>
  );
};

export default SidebarDesktop;
